const translations = {
  name: 'Nombre',
  namePlural: 'Nombre en plural',
  icon: 'Icono',
  title: 'Tipo de lugares',
  titleEdit: 'Editar tipo de lugares',
  insertedAt: 'Creado en: ',
  updatedAt: 'Actualizado en: ',
  'edit.title': 'Editando',
  'create.title': 'Creando',
  placeType: 'tipo de lugar',
  requiredField: 'Campo obligatorio',
  successSave: '¡Tipo de lugar guardado con éxito!',
  errorSave: '¡Ocurrió un error al guardar!'
}

export default translations
